import { createApiConfig } from "../config";

import { QR_LICENSE_API_URL } from "../routes"

const apiConfig = createApiConfig();

// Mute QR License

export const muteQRLicense = (id,data) => {
    return apiConfig.put(`${QR_LICENSE_API_URL}/status/${id}`, data);
};